import request from "@/plugins/request.js";
import axiosAjax from "@/plugins/axios.js";

export default __VITE_TYPE__ === "APP" ? axiosAjax : request;
